"use strict";
import { Flex, Text, TouchableArea } from "ui/src";
import Trace from "features/telemetry/Trace";
export const ActionCard = ({
  title,
  blurb,
  onPress,
  icon,
  elementName,
  containerProps,
  hoverStyle,
  leftAlign = false,
  BackgroundImageWrapperCallback
}) => <Trace logPress element={elementName}>
    <TouchableArea
  backgroundColor={BackgroundImageWrapperCallback ? void 0 : "$surface1"}
  borderColor="$surface3"
  borderRadius="$rounded24"
  borderWidth="$spacing1"
  overflow="hidden"
  hoverStyle={hoverStyle}
  onPress={onPress}
>
      <BackgroundWrapper BackgroundImageWrapper={BackgroundImageWrapperCallback}>
        <Flex
  shrink
  centered={!leftAlign}
  alignContent="center"
  gap="$spacing4"
  px="$spacing20"
  py="$spacing12"
  {...containerProps}
>
          {icon}
          <Flex shrink centered={!leftAlign} alignContent={leftAlign ? "flex-start" : "center"}>
            <Text textAlign={leftAlign ? "left" : "center"} variant="buttonLabel2">
              {title}
            </Text>
            <Text color="$neutral2" textAlign={leftAlign ? "left" : "center"} variant="body3">
              {blurb}
            </Text>
          </Flex>
        </Flex>
      </BackgroundWrapper>
    </TouchableArea>
  </Trace>;
const BackgroundWrapper = ({
  children,
  BackgroundImageWrapper
}) => {
  return BackgroundImageWrapper !== void 0 ? <BackgroundImageWrapper>{children}</BackgroundImageWrapper> : <Flex>{children}</Flex>;
};
